import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/layout/Navbar";
import AuthModal from "./components/auth/AuthModal";
import LiveMatchesPage from "./pages/LiveMatchesPage";
import MatchDetailPage from "./pages/MatchDetailPage";
import LeaderboardPage from "./pages/LeaderboardPage";
import ProfilePage from "./pages/ProfilePage";
import SchedulePage from "./pages/SchedulePage";
import AdminPlayersPage from "./pages/AdminPlayersPage";
import AdminPlayerHistoryPage from "./pages/AdminPlayerHistoryPage";
import LiveFeedPage from "./pages/LiveFeedPage";
import LiveMatchDetailPage from "./pages/LiveMatchDetailPage";
import HistoryPage from "./pages/HistoryPage";
import { RouteTracker } from "./components/common/RouteTracker";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteTracker />
          <Navbar />
          <AuthModal />
          <Routes>
            <Route path="/" element={<LiveMatchesPage />} />
            <Route path="/matches/:id" element={<MatchDetailPage />} />
            <Route path="/leaderboard" element={<LeaderboardPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/live" element={<LiveFeedPage />} />
            <Route path="/live/match/:id" element={<LiveMatchDetailPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/admin/players" element={<AdminPlayersPage />} />
            <Route path="/admin/players/:id/history" element={<AdminPlayerHistoryPage />} />
          </Routes>
          <Toaster theme="dark" position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
